<template>
    <RedesignFormItem :label="$t('layout.config.widgetTableRowPadding')">
        <RedesignInputNumber
            v-model="model"
            :max-value="optionConfigs.WidgetTableRowPadding.max"
            :min-value="optionConfigs.WidgetTableRowPadding.min"
            :step="optionConfigs.WidgetTableRowPadding.step"
            size="small"
            placeholder="12"
        />
    </RedesignFormItem>
</template>

<script setup lang="ts">
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import RedesignInputNumber from '@/components/RedesignBaseComponents/Inputs/RedesignInputNumber.vue'
import { computed } from 'vue'
import { optionConfigs } from '@/views/DashboardSettings/LayoutManagement/layout-management'

const props = defineProps<{
    value?: number
}>()

const emit = defineEmits([ 'input' ])

const model = computed({
    get () {
        return props.value
    },
    set (val) {
        emit('input', val)
    }
})
</script>
